import axios, { AxiosResponse } from "axios";

import {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest
} from "@/Utils/Service/BackendService";

import { ZomentumEntities } from "@/Contracts";

import {
	CustomFieldsResponse,
	CustomField,
	CustomFieldFormValues,
	CustomFieldCount,
	ValidateDeleteCustomFieldResponse
} from "@/Contracts/Settings";

const customFieldsUrl =
	"/v2/custom/fields?entity_type={entity_type}&include_system_fields=true";
const deleteCustomFieldUrlAsync = "/v2/custom/fields/async/{custom_field_id}";
const addCustomFieldUrl = "/v2/custom/fields";
const publicCustomFieldsUrl = "/v2/public/custom/fields";
const editCustomFieldUrl = "/v2/custom/fields/{custom_field_id}";
const reorderCustomFieldUrl = "/v2/custom/fields/reorder";
const countCustomFieldsUrl = "/v2/custom/fields/count";
const validateDeleteCustomFieldUrl = "/v2/custom/fields/delete/validate/:id";
const vendorCustomFieldsUrl = "/v2/vendor/:vendorId/custom/fields";

export const getCustomFields = async (
	entityType: ZomentumEntities
): Promise<CustomFieldsResponse> => {
	try {
		const response: AxiosResponse<CustomFieldsResponse> = await axios(
			getRequest(
				customFieldsUrl.replace("{entity_type}", entityType),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getVendorCustomFields = async (
	vendorId: string
): Promise<CustomFieldsResponse> => {
	try {
		const response: AxiosResponse<CustomFieldsResponse> = await axios(
			getRequest(
				vendorCustomFieldsUrl.replace(":vendorId", vendorId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getPublicCustomFields = async (
	entityType: ZomentumEntities,
	companyId?: string
): Promise<CustomFieldsResponse> => {
	try {
		const queryParam = `?company_id=${companyId}&entity_type=${entityType}`;
		const response: AxiosResponse<CustomFieldsResponse> = await axios(
			getRequest(
				publicCustomFieldsUrl + queryParam,
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCustomFieldAsync = async (
	customField: CustomField
): Promise<string> => {
	try {
		const response: AxiosResponse<string> = await axios(
			deleteRequest(
				deleteCustomFieldUrlAsync.replace(
					"{custom_field_id}",
					customField.id
				),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addCustomField = async (
	addCustomFieldRequest: CustomFieldFormValues
): Promise<CustomField> => {
	try {
		const response: AxiosResponse<CustomField> = await axios(
			postRequest(
				addCustomFieldUrl,
				addCustomFieldRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editCustomField = async (
	customField: CustomFieldFormValues
): Promise<CustomField> => {
	try {
		const response: AxiosResponse<CustomField> = await axios(
			putRequest(
				editCustomFieldUrl.replace("{custom_field_id}", customField.id),
				customField,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const reorderCustomField = async (
	reorderedCustomFieldList: CustomField[],
	entityType: ZomentumEntities
): Promise<CustomFieldsResponse> => {
	try {
		const response: AxiosResponse<CustomFieldsResponse> = await axios(
			putRequest(
				reorderCustomFieldUrl,
				{
					entity_type: entityType,
					fields: reorderedCustomFieldList.map(
						salesActivityAutomation => salesActivityAutomation.id
					)
				},
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const countCustomFields = async (): Promise<CustomFieldCount> => {
	try {
		const response: AxiosResponse<CustomFieldCount> = await axios(
			getRequest(countCustomFieldsUrl, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const validateDeleteCustomField = async (
	id: string
): Promise<ValidateDeleteCustomFieldResponse> => {
	try {
		const response: AxiosResponse<ValidateDeleteCustomFieldResponse> =
			await axios(
				getRequest(
					validateDeleteCustomFieldUrl.replace(":id", id),
					null,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
